<script setup lang="ts">
import './assets/style.scss'
import { useToast } from '@/shared/ui'
import VToastItem from '@/shared/ui/VToast/ui/VToastItem.vue'
import { onMounted, ref, watchEffect } from 'vue'

const props = defineProps({
  isAudio: {
    type: Boolean,
    default: false,
  },
})

const beep = ref()
const toast = useToast()

/* Изменяем оповещения при смене параметров */
watchEffect(() => (toast.isAudio = props.isAudio))

/* Устанавливаем звук оповещения */
onMounted(() => {
  if (beep.value) toast.addAudio(beep.value as HTMLAudioElement)
})
</script>

<template>
  <div class="v-toast__list">
    <div v-if="toast.list.length > 1" class="v-toast__clear">
      <div class="v-toast__clear-btn" @click="toast.clear">
        {{ $t('itf.clear_all') }}
      </div>
    </div>

    <TransitionGroup name="v-toast__trs">
      <VToastItem v-for="item in toast.list" :item :key="item.id" />
    </TransitionGroup>
  </div>

  <div class="v-toast__audio">
    <audio ref="beep" src="/sound/beep.mp3" preload="auto" />
  </div>
</template>
